import { useMemo } from "react";

import * as UI from "../../../../../../modules/ui-kit";
import { UNITS_OF_MEASUREMENT } from "../../../../domain/units";

export default function UnitOfMeasurementSelect({ onChange, value }) {
    const isKnown = !value || (UNITS_OF_MEASUREMENT as readonly string[]).includes(value);

    const options = useMemo(
        () => {
            const base = UNITS_OF_MEASUREMENT.map((u) => ({
                label: u === "" ? "-" : u,
                value: u,
            }));
            if (!isKnown && value) {
                base.push({ label: `${ value } (invalid)`, value });
            }
            return base;
        },
        [value, isKnown],
    );

    return (
        <UI.Select
            isOptionDisabled={ (option) => !isKnown && option.value === value }
            onSelect={ onChange }
            options={ options }
            value={ value ?? "" }
        />
    );
}
